import { render, staticRenderFns } from "./SettingsChartWidget.vue?vue&type=template&id=be1c03fe&scoped=true"
import script from "./SettingsChartWidget.vue?vue&type=script&lang=js"
export * from "./SettingsChartWidget.vue?vue&type=script&lang=js"
import style0 from "./SettingsChartWidget.vue?vue&type=style&index=0&id=be1c03fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1c03fe",
  null
  
)

export default component.exports